/**
 * Search options shared by the discussion list override and the extras shown
 * under it. Reset whenever the query changes.
 */
export const splitState = { query: null, range: 'all', fuzzy: false, suggestion: null };

export function resetFor(query) {
  if (splitState.query !== query) {
    Object.assign(splitState, { query, range: 'all', fuzzy: false, suggestion: null });
  }
}
